import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaChevronRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  if (location.pathname === '/') return null;

  const formatBreadcrumb = (str) => {
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://avanshyadav.netlify.app/"
      },
      ...pathnames.map((name, index) => ({
        "@type": "ListItem",
        "position": index + 2,
        "name": formatBreadcrumb(name),
        "item": `https://avanshyadav.netlify.app/${pathnames.slice(0, index + 1).join('/')}`
      }))
    ]
  };

  return (
    <>
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
    <motion.nav
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center gap-2 text-sm mb-8 flex-wrap"
      aria-label="Breadcrumb"
    >
      <Link
        to="/"
        className="flex items-center gap-2 text-gray-400 hover:text-violet-400 transition-colors"
      >
        <FaHome />
        <span>Home</span>
      </Link>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;

        return (
          <div key={name} className="flex items-center gap-2">
            <FaChevronRight className="text-gray-600 text-xs" />
            {isLast ? (
              <span className="text-violet-400 font-medium">
                {formatBreadcrumb(name)}
              </span>
            ) : (
              <Link
                to={routeTo}
                className="text-gray-400 hover:text-violet-400 transition-colors"
              >
                {formatBreadcrumb(name)}
              </Link>
            )}
          </div>
        );
      })}
    </motion.nav>
    </>
  );
};

export default Breadcrumb;
